<button title="{{ 'menu.shopCard.link' | transloco }}" data-testid="shop-card" (click)="handleOpenShop()">
  <section [style.--background-image-url]="backgroundImageUrl$$()">
    <div class="shop-card-content">
      <div class="shop-card-title">{{ 'menu.shopCard.title' | transloco }}</div>
      <span class="shop-card-description">{{ 'menu.shopCard.description' | transloco }}</span>
    </div>

    <lib-app-button [fill]="'clear'" size="small" class="shop-card-link">
      <ion-icon name="arrow-right" class="link-icon" slot="end"></ion-icon>
      {{ 'menu.shopCard.link' | transloco }}
    </lib-app-button>
  </section>
</button>
